"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getYears = exports.getWpUserById = exports.getTrustPilot = exports.getTikTokVideos = exports.getTSWDestinations = exports.getSubPages = exports.getSubCategory = exports.getMusicArticles = exports.getJobs = exports.getInstagram = exports.getHighlightsBySlug = exports.getHighlights = exports.getHighlightArticles = exports.getGalleryTags = exports.getGalleryItems = exports.getFaqBySlug = exports.getFaqArticlesBySearch = exports.getFaqArticlesByCategory = exports.getFaqArticles = exports.getEmployees = exports.getDestinations = exports.getDestination = exports.getCrews = exports.getBlogBySlug = exports.getBlogArticles = exports.getArtists = exports.getArtistBySlug = exports.crewFinderContactBooker = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _util = require("util");
var _wpApi = require("../helpers/wp-api");
var _config = require("../config");
var _envConstants = require("../../env-constants");
// import fetch from 'isomorphic-unfetch';

var baseUrl = _config.config.apiUrl;
var getBlogBySlug = exports.getBlogBySlug = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(slug) {
    var posts;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          slug = slug.replace(/\d{4}\/\d{2}\//, ''); // Remove dates, not used for querying
          slug = slug.split('/')[0]; // If multiple paths, take the first
          _context.next = 5;
          return (0, _wpApi.getWPResource)("posts?slug=".concat(slug));
        case 5:
          posts = _context.sent;
          if (!(posts.length > 0)) {
            _context.next = 8;
            break;
          }
          return _context.abrupt("return", posts[0]);
        case 8:
          return _context.abrupt("return", null);
        case 11:
          _context.prev = 11;
          _context.t0 = _context["catch"](0);
          return _context.abrupt("return", null);
        case 14:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[0, 11]]);
  }));
  return function getBlogBySlug(_x) {
    return _ref.apply(this, arguments);
  };
}();
var getFaqBySlug = exports.getFaqBySlug = /*#__PURE__*/function () {
  var _ref2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(slug) {
    var posts;
    return _regenerator["default"].wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _context2.prev = 0;
          slug = slug.replace(/\d{4}\/\d{2}\//, ''); // Remove dates, not used for querying
          slug = slug.split('/')[0]; // If multiple paths, take the first
          _context2.next = 5;
          return (0, _wpApi.getWPResource)("faq?slug=".concat(slug));
        case 5:
          posts = _context2.sent;
          if (!(posts.length > 0)) {
            _context2.next = 8;
            break;
          }
          return _context2.abrupt("return", posts[0]);
        case 8:
          return _context2.abrupt("return", null);
        case 11:
          _context2.prev = 11;
          _context2.t0 = _context2["catch"](0);
          return _context2.abrupt("return", null);
        case 14:
        case "end":
          return _context2.stop();
      }
    }, _callee2, null, [[0, 11]]);
  }));
  return function getFaqBySlug(_x2) {
    return _ref2.apply(this, arguments);
  };
}();
var getArtistBySlug = exports.getArtistBySlug = /*#__PURE__*/function () {
  var _ref3 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3(slug) {
    var posts;
    return _regenerator["default"].wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          _context3.prev = 0;
          slug = slug.replace(/\d{4}\/\d{2}\//, ''); // Remove dates, not used for querying
          slug = slug.split('/')[0]; // If multiple paths, take the first
          _context3.next = 5;
          return (0, _wpApi.getWPResource)("artists?slug=".concat(slug));
        case 5:
          posts = _context3.sent;
          if (!(posts.length > 0)) {
            _context3.next = 8;
            break;
          }
          return _context3.abrupt("return", posts[0]);
        case 8:
          return _context3.abrupt("return", null);
        case 11:
          _context3.prev = 11;
          _context3.t0 = _context3["catch"](0);
          return _context3.abrupt("return", null);
        case 14:
        case "end":
          return _context3.stop();
      }
    }, _callee3, null, [[0, 11]]);
  }));
  return function getArtistBySlug(_x3) {
    return _ref3.apply(this, arguments);
  };
}();

// /wp-json/wp/v2/categories?slug=press

var getBlogArticles = exports.getBlogArticles = /*#__PURE__*/function () {
  var _ref4 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4(page, category, tags) {
    var perPage,
      categoryId,
      tagQuery,
      categories,
      pageQuery,
      postsResponse,
      _args4 = arguments;
    return _regenerator["default"].wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          perPage = _args4.length > 3 && _args4[3] !== undefined ? _args4[3] : 9;
          _context4.prev = 1;
          categoryId = (0, _wpApi.getBlogCategoryId)(); // blog type
          tagQuery = tags ? "&tags=".concat(tags.map(function (tag) {
            return tag.term_id || tag;
          }).join()) : ''; // handle multiple tags as well
          if (!category) {
            _context4.next = 13;
            break;
          }
          if ((0, _util.isArray)(category)) {
            _context4.next = 12;
            break;
          }
          _context4.next = 8;
          return (0, _wpApi.getWPResource)("categories?slug=".concat(category));
        case 8:
          categories = _context4.sent;
          if (categories) {
            categoryId = categories[0].id;
            perPage = 15;
          }
          _context4.next = 13;
          break;
        case 12:
          categoryId = category.map(function (cat) {
            return cat.term_id || cat;
          }).join(); // handle multiple categories as well
        case 13:
          pageQuery = page ? "&page=".concat(page) : '';
          _context4.next = 16;
          return (0, _wpApi.getWPBlogs)("posts?categories=".concat(categoryId).concat(tagQuery).concat(pageQuery, "&per_page=").concat(perPage));
        case 16:
          postsResponse = _context4.sent;
          if (!postsResponse) {
            _context4.next = 20;
            break;
          }
          postsResponse.pagesCount = postsResponse.postsCount / perPage;
          return _context4.abrupt("return", postsResponse);
        case 20:
          return _context4.abrupt("return", null);
        case 23:
          _context4.prev = 23;
          _context4.t0 = _context4["catch"](1);
          return _context4.abrupt("return", _context4.t0);
        case 26:
        case "end":
          return _context4.stop();
      }
    }, _callee4, null, [[1, 23]]);
  }));
  return function getBlogArticles(_x4, _x5, _x6) {
    return _ref4.apply(this, arguments);
  };
}();
var getHighlightArticles = exports.getHighlightArticles = /*#__PURE__*/function () {
  var _ref5 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee5() {
    var page,
      category,
      tags,
      perPage,
      categoryId,
      tagQuery,
      categories,
      qs,
      posts,
      _args5 = arguments;
    return _regenerator["default"].wrap(function _callee5$(_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          page = _args5.length > 0 && _args5[0] !== undefined ? _args5[0] : null;
          category = _args5.length > 1 ? _args5[1] : undefined;
          tags = _args5.length > 2 ? _args5[2] : undefined;
          _context5.prev = 3;
          perPage = 9; // default posts per blog
          categoryId = (0, _wpApi.getBlogCategoryId)(); // blog type
          tagQuery = tags ? "&tags=".concat(tags.map(function (tag) {
            return tag.term_id;
          }).join()) : ''; // handle multiple tags as well
          if (!category) {
            _context5.next = 16;
            break;
          }
          if ((0, _util.isArray)(category)) {
            _context5.next = 15;
            break;
          }
          _context5.next = 11;
          return (0, _wpApi.getWPResource)("categories?slug=".concat(category));
        case 11:
          categories = _context5.sent;
          if (categories) {
            categoryId = categories[0].id;
            perPage = 15;
          }
          _context5.next = 16;
          break;
        case 15:
          categoryId = category.map(function (cat) {
            return cat.term_id;
          }).join(); // handle multiple categories as well
        case 16:
          qs = "?categories=".concat(categoryId).concat(tagQuery);
          if (page) {
            qs = "".concat(qs, "&page=").concat(page, "&per_page=").concat(perPage);
          } else {
            qs = "".concat(qs, "&per_page=100"); // If no page is passed then we'll just get loads
          }
          _context5.next = 20;
          return (0, _wpApi.getWPResource)("highlights".concat(qs));
        case 20:
          posts = _context5.sent;
          if (!posts) {
            _context5.next = 23;
            break;
          }
          return _context5.abrupt("return", posts);
        case 23:
          return _context5.abrupt("return", null);
        case 26:
          _context5.prev = 26;
          _context5.t0 = _context5["catch"](3);
          return _context5.abrupt("return", _context5.t0);
        case 29:
        case "end":
          return _context5.stop();
      }
    }, _callee5, null, [[3, 26]]);
  }));
  return function getHighlightArticles() {
    return _ref5.apply(this, arguments);
  };
}();
var getFaqArticles = exports.getFaqArticles = /*#__PURE__*/function () {
  var _ref6 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee6(page, category, tags) {
    var perPage,
      categoryId,
      postsResponse,
      categories,
      _args6 = arguments;
    return _regenerator["default"].wrap(function _callee6$(_context6) {
      while (1) switch (_context6.prev = _context6.next) {
        case 0:
          perPage = _args6.length > 3 && _args6[3] !== undefined ? _args6[3] : 9;
          _context6.prev = 1;
          categoryId = (0, _wpApi.getBlogCategoryId)(); // blog type
          postsResponse = null;
          if (!category) {
            _context6.next = 18;
            break;
          }
          if ((0, _util.isArray)(category)) {
            _context6.next = 12;
            break;
          }
          _context6.next = 8;
          return (0, _wpApi.getWPResource)("categories?slug=".concat(category));
        case 8:
          categories = _context6.sent;
          if (categories) {
            categoryId = categories[0].id;
          }
          _context6.next = 13;
          break;
        case 12:
          categoryId = category.map(function (cat) {
            return cat.term_id || cat;
          }).join(); // handle multiple categories as well
        case 13:
          _context6.next = 15;
          return (0, _wpApi.getWPBlogs)("faq?categories=".concat(categoryId, "&page=").concat(page, "&per_page=").concat(perPage));
        case 15:
          postsResponse = _context6.sent;
          _context6.next = 21;
          break;
        case 18:
          _context6.next = 20;
          return (0, _wpApi.getWPBlogs)("faq?page=".concat(page, "&per_page=").concat(perPage));
        case 20:
          postsResponse = _context6.sent;
        case 21:
          if (!postsResponse) {
            _context6.next = 24;
            break;
          }
          postsResponse.pagesCount = postsResponse.postsCount / perPage;
          return _context6.abrupt("return", postsResponse);
        case 24:
          return _context6.abrupt("return", null);
        case 27:
          _context6.prev = 27;
          _context6.t0 = _context6["catch"](1);
          return _context6.abrupt("return", _context6.t0);
        case 30:
        case "end":
          return _context6.stop();
      }
    }, _callee6, null, [[1, 27]]);
  }));
  return function getFaqArticles(_x7, _x8, _x9) {
    return _ref6.apply(this, arguments);
  };
}();
var getFaqArticlesBySearch = exports.getFaqArticlesBySearch = /*#__PURE__*/function () {
  var _ref7 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee7(search) {
    var posts;
    return _regenerator["default"].wrap(function _callee7$(_context7) {
      while (1) switch (_context7.prev = _context7.next) {
        case 0:
          _context7.prev = 0;
          _context7.next = 3;
          return (0, _wpApi.getWPBlogs)("faq?search=".concat(search));
        case 3:
          posts = _context7.sent;
          if (!posts) {
            _context7.next = 6;
            break;
          }
          return _context7.abrupt("return", posts);
        case 6:
          return _context7.abrupt("return", null);
        case 9:
          _context7.prev = 9;
          _context7.t0 = _context7["catch"](0);
          return _context7.abrupt("return", _context7.t0);
        case 12:
        case "end":
          return _context7.stop();
      }
    }, _callee7, null, [[0, 9]]);
  }));
  return function getFaqArticlesBySearch(_x10) {
    return _ref7.apply(this, arguments);
  };
}();
var getFaqArticlesByCategory = exports.getFaqArticlesByCategory = /*#__PURE__*/function () {
  var _ref8 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee8(categoryId) {
    var posts;
    return _regenerator["default"].wrap(function _callee8$(_context8) {
      while (1) switch (_context8.prev = _context8.next) {
        case 0:
          _context8.prev = 0;
          _context8.next = 3;
          return (0, _wpApi.getWPResource)("faq?categories=".concat(categoryId));
        case 3:
          posts = _context8.sent;
          if (!posts) {
            _context8.next = 6;
            break;
          }
          return _context8.abrupt("return", posts);
        case 6:
          return _context8.abrupt("return", null);
        case 9:
          _context8.prev = 9;
          _context8.t0 = _context8["catch"](0);
          return _context8.abrupt("return", _context8.t0);
        case 12:
        case "end":
          return _context8.stop();
      }
    }, _callee8, null, [[0, 9]]);
  }));
  return function getFaqArticlesByCategory(_x11) {
    return _ref8.apply(this, arguments);
  };
}();
var getMusicArticles = exports.getMusicArticles = /*#__PURE__*/function () {
  var _ref9 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee9(page, category) {
    var perPage,
      categoryId,
      categories,
      posts,
      _args9 = arguments;
    return _regenerator["default"].wrap(function _callee9$(_context9) {
      while (1) switch (_context9.prev = _context9.next) {
        case 0:
          perPage = _args9.length > 2 && _args9[2] !== undefined ? _args9[2] : 9;
          _context9.prev = 1;
          categoryId = 577; // blog
          if (!category) {
            _context9.next = 8;
            break;
          }
          _context9.next = 6;
          return (0, _wpApi.getWPResource)("categories?slug=".concat(category));
        case 6:
          categories = _context9.sent;
          if (categories) {
            categoryId = categories[0].id;
            perPage = 15;
          }
        case 8:
          _context9.next = 10;
          return (0, _wpApi.getWPResource)("posts?categories=".concat(categoryId, "&page=").concat(page, "&per_page=").concat(perPage));
        case 10:
          posts = _context9.sent;
          if (!posts) {
            _context9.next = 13;
            break;
          }
          return _context9.abrupt("return", posts);
        case 13:
          return _context9.abrupt("return", null);
        case 16:
          _context9.prev = 16;
          _context9.t0 = _context9["catch"](1);
          return _context9.abrupt("return", _context9.t0);
        case 19:
        case "end":
          return _context9.stop();
      }
    }, _callee9, null, [[1, 16]]);
  }));
  return function getMusicArticles(_x12, _x13) {
    return _ref9.apply(this, arguments);
  };
}();
var getHighlightsBySlug = exports.getHighlightsBySlug = /*#__PURE__*/function () {
  var _ref10 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee10(page, category) {
    var perPage, categoryId, categories, posts;
    return _regenerator["default"].wrap(function _callee10$(_context10) {
      while (1) switch (_context10.prev = _context10.next) {
        case 0:
          _context10.prev = 0;
          perPage = 9; // default posts per blog
          categoryId = 577; // blog
          if (!category) {
            _context10.next = 8;
            break;
          }
          _context10.next = 6;
          return (0, _wpApi.getWPResource)("categories?slug=".concat(category));
        case 6:
          categories = _context10.sent;
          if (categories) {
            categoryId = categories[0].id;
            perPage = 15;
          }
        case 8:
          _context10.next = 10;
          return (0, _wpApi.getWPResource)("highlights?categories=".concat(categoryId, "&page=").concat(page, "&per_page=").concat(perPage));
        case 10:
          posts = _context10.sent;
          if (!posts) {
            _context10.next = 13;
            break;
          }
          return _context10.abrupt("return", posts);
        case 13:
          return _context10.abrupt("return", null);
        case 16:
          _context10.prev = 16;
          _context10.t0 = _context10["catch"](0);
          return _context10.abrupt("return", _context10.t0);
        case 19:
        case "end":
          return _context10.stop();
      }
    }, _callee10, null, [[0, 16]]);
  }));
  return function getHighlightsBySlug(_x14, _x15) {
    return _ref10.apply(this, arguments);
  };
}();

// export const getWordpressPageBySlug = async(slug) => {
//   try {
//     const response = await fetch(`${baseUrl}/cms/api/pages/${slug}`);

//     const page = await response.json();
//     if (page) {
//       return parseWPJson(page);
//     }
//     return null;
//   } catch (error) {
//     return error;
//   }
// };

//legacy
var getDestinations = exports.getDestinations = /*#__PURE__*/function () {
  var _ref11 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee11() {
    var response, destinations;
    return _regenerator["default"].wrap(function _callee11$(_context11) {
      while (1) switch (_context11.prev = _context11.next) {
        case 0:
          _context11.next = 2;
          return fetch("".concat(baseUrl, "/cms/api/destinations"));
        case 2:
          response = _context11.sent;
          _context11.next = 5;
          return response.json();
        case 5:
          destinations = _context11.sent;
          if (!destinations) {
            _context11.next = 8;
            break;
          }
          return _context11.abrupt("return", destinations.map(_wpApi.parseWPJson));
        case 8:
          return _context11.abrupt("return", null);
        case 9:
        case "end":
          return _context11.stop();
      }
    }, _callee11);
  }));
  return function getDestinations() {
    return _ref11.apply(this, arguments);
  };
}();
var getCrews = exports.getCrews = /*#__PURE__*/function () {
  var _ref12 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee12() {
    var response, crews;
    return _regenerator["default"].wrap(function _callee12$(_context12) {
      while (1) switch (_context12.prev = _context12.next) {
        case 0:
          _context12.next = 2;
          return fetch("".concat(baseUrl, "/api/yl/crew-finder"));
        case 2:
          response = _context12.sent;
          _context12.next = 5;
          return response.json();
        case 5:
          crews = _context12.sent;
          if (!crews) {
            _context12.next = 8;
            break;
          }
          return _context12.abrupt("return", crews);
        case 8:
          return _context12.abrupt("return", null);
        case 9:
        case "end":
          return _context12.stop();
      }
    }, _callee12);
  }));
  return function getCrews() {
    return _ref12.apply(this, arguments);
  };
}();
var getDestination = exports.getDestination = /*#__PURE__*/function () {
  var _ref13 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee13(destId) {
    var response, destinations, destination;
    return _regenerator["default"].wrap(function _callee13$(_context13) {
      while (1) switch (_context13.prev = _context13.next) {
        case 0:
          _context13.next = 2;
          return fetch("".concat(baseUrl, "/api/yl/destinations"));
        case 2:
          response = _context13.sent;
          _context13.next = 5;
          return response.json();
        case 5:
          destinations = _context13.sent;
          destination = destinations.find(function (d) {
            return d.id === parseInt(destId, 10);
          });
          if (!destination) {
            _context13.next = 9;
            break;
          }
          return _context13.abrupt("return", destination);
        case 9:
          return _context13.abrupt("return", null);
        case 10:
        case "end":
          return _context13.stop();
      }
    }, _callee13);
  }));
  return function getDestination(_x16) {
    return _ref13.apply(this, arguments);
  };
}();
var getTSWDestinations = exports.getTSWDestinations = /*#__PURE__*/function () {
  var _ref14 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee14() {
    var response, destinations;
    return _regenerator["default"].wrap(function _callee14$(_context14) {
      while (1) switch (_context14.prev = _context14.next) {
        case 0:
          _context14.next = 2;
          return fetch("".concat(baseUrl, "/api/booking-options"));
        case 2:
          response = _context14.sent;
          _context14.next = 5;
          return response.json();
        case 5:
          destinations = _context14.sent;
          if (!destinations) {
            _context14.next = 8;
            break;
          }
          return _context14.abrupt("return", destinations);
        case 8:
          return _context14.abrupt("return", null);
        case 9:
        case "end":
          return _context14.stop();
      }
    }, _callee14);
  }));
  return function getTSWDestinations() {
    return _ref14.apply(this, arguments);
  };
}();
var crewFinderContactBooker = exports.crewFinderContactBooker = /*#__PURE__*/function () {
  var _ref15 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee15(bookingId, contactData) {
    var response, data;
    return _regenerator["default"].wrap(function _callee15$(_context15) {
      while (1) switch (_context15.prev = _context15.next) {
        case 0:
          _context15.next = 2;
          return fetch("".concat(baseUrl, "/api/yl/crew-finder/contact/").concat(bookingId), {
            method: 'POST',
            body: JSON.stringify(contactData),
            credentials: 'same-origin',
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json'
            }
          });
        case 2:
          response = _context15.sent;
          _context15.next = 5;
          return response.json();
        case 5:
          data = _context15.sent;
          return _context15.abrupt("return", data);
        case 7:
        case "end":
          return _context15.stop();
      }
    }, _callee15);
  }));
  return function crewFinderContactBooker(_x17, _x18) {
    return _ref15.apply(this, arguments);
  };
}();
var getEmployees = exports.getEmployees = /*#__PURE__*/function () {
  var _ref16 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee16() {
    var response, posts;
    return _regenerator["default"].wrap(function _callee16$(_context16) {
      while (1) switch (_context16.prev = _context16.next) {
        case 0:
          _context16.next = 2;
          return fetch("".concat(baseUrl, "/wp-json/wp/v2/team?per_page=100"));
        case 2:
          response = _context16.sent;
          _context16.next = 5;
          return response.json();
        case 5:
          posts = _context16.sent;
          if (!(Array.isArray(posts) && posts.length)) {
            _context16.next = 8;
            break;
          }
          return _context16.abrupt("return", posts.map(_wpApi.parseWPJson));
        case 8:
          return _context16.abrupt("return", null);
        case 9:
        case "end":
          return _context16.stop();
      }
    }, _callee16);
  }));
  return function getEmployees() {
    return _ref16.apply(this, arguments);
  };
}();
var getArtists = exports.getArtists = /*#__PURE__*/function () {
  var _ref17 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee17() {
    var perPage,
      response,
      posts,
      _args17 = arguments;
    return _regenerator["default"].wrap(function _callee17$(_context17) {
      while (1) switch (_context17.prev = _context17.next) {
        case 0:
          perPage = _args17.length > 0 && _args17[0] !== undefined ? _args17[0] : 100;
          _context17.next = 3;
          return fetch("".concat(baseUrl, "/wp-json/wp/v2/artists?per_page=").concat(perPage));
        case 3:
          response = _context17.sent;
          _context17.next = 6;
          return response.json();
        case 6:
          posts = _context17.sent;
          if (!(Array.isArray(posts) && posts.length)) {
            _context17.next = 9;
            break;
          }
          return _context17.abrupt("return", posts.map(_wpApi.parseWPJson));
        case 9:
          return _context17.abrupt("return", null);
        case 10:
        case "end":
          return _context17.stop();
      }
    }, _callee17);
  }));
  return function getArtists() {
    return _ref17.apply(this, arguments);
  };
}();
var getHighlights = exports.getHighlights = /*#__PURE__*/function () {
  var _ref18 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee18(id) {
    var highlights;
    return _regenerator["default"].wrap(function _callee18$(_context18) {
      while (1) switch (_context18.prev = _context18.next) {
        case 0:
          _context18.next = 2;
          return (0, _wpApi.getWPResource)("highlights".concat(id ? "?categories=".concat(id, "&per_page=30") : '?per_page=30'));
        case 2:
          highlights = _context18.sent;
          if (!highlights) {
            _context18.next = 5;
            break;
          }
          return _context18.abrupt("return", highlights);
        case 5:
          return _context18.abrupt("return", null);
        case 6:
        case "end":
          return _context18.stop();
      }
    }, _callee18);
  }));
  return function getHighlights(_x19) {
    return _ref18.apply(this, arguments);
  };
}();
var getYears = exports.getYears = /*#__PURE__*/function () {
  var _ref19 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee19() {
    var years;
    return _regenerator["default"].wrap(function _callee19$(_context19) {
      while (1) switch (_context19.prev = _context19.next) {
        case 0:
          _context19.next = 2;
          return (0, _wpApi.getWPResource)('timelines?per_page=100');
        case 2:
          years = _context19.sent;
          if (!years) {
            _context19.next = 5;
            break;
          }
          return _context19.abrupt("return", years);
        case 5:
          return _context19.abrupt("return", null);
        case 6:
        case "end":
          return _context19.stop();
      }
    }, _callee19);
  }));
  return function getYears() {
    return _ref19.apply(this, arguments);
  };
}();
var getJobs = exports.getJobs = /*#__PURE__*/function () {
  var _ref20 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee20(slug) {
    var jobs;
    return _regenerator["default"].wrap(function _callee20$(_context20) {
      while (1) switch (_context20.prev = _context20.next) {
        case 0:
          _context20.next = 2;
          return (0, _wpApi.getWPResource)("jobs?per_page=100".concat(slug ? "&slug=".concat(slug) : ''));
        case 2:
          jobs = _context20.sent;
          if (!jobs) {
            _context20.next = 5;
            break;
          }
          return _context20.abrupt("return", jobs);
        case 5:
          return _context20.abrupt("return", null);
        case 6:
        case "end":
          return _context20.stop();
      }
    }, _callee20);
  }));
  return function getJobs(_x20) {
    return _ref20.apply(this, arguments);
  };
}();

//legacy
var getTrustPilot = exports.getTrustPilot = /*#__PURE__*/function () {
  var _ref21 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee21() {
    var response, data;
    return _regenerator["default"].wrap(function _callee21$(_context21) {
      while (1) switch (_context21.prev = _context21.next) {
        case 0:
          _context21.next = 2;
          return fetch("".concat(baseUrl, "/cms/api/trustpilot"));
        case 2:
          response = _context21.sent;
          _context21.next = 5;
          return response.json();
        case 5:
          data = _context21.sent;
          if (!(data && !data.error)) {
            _context21.next = 8;
            break;
          }
          return _context21.abrupt("return", data);
        case 8:
          return _context21.abrupt("return", null);
        case 9:
        case "end":
          return _context21.stop();
      }
    }, _callee21);
  }));
  return function getTrustPilot() {
    return _ref21.apply(this, arguments);
  };
}();
var getInstagram = exports.getInstagram = /*#__PURE__*/function () {
  var _ref22 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee22() {
    var data, _data;
    return _regenerator["default"].wrap(function _callee22$(_context22) {
      while (1) switch (_context22.prev = _context22.next) {
        case 0:
          if (!(_envConstants.ENV.SITE !== 'day8')) {
            _context22.next = 8;
            break;
          }
          _context22.next = 3;
          return fetch("https://graph.instagram.com/me/media?fields=id,media_url,thumbnail_url,caption&access_token=".concat(_envConstants.ENV.INSTAGRAM_TOKENS[_envConstants.ENV.SITE], "&limit=16"), {
            method: 'GET'
          }).then(function (response) {
            return response.json();
          }).then(function (r) {
            return r.data;
          });
        case 3:
          data = _context22.sent;
          if (!(data && !data.error)) {
            _context22.next = 6;
            break;
          }
          return _context22.abrupt("return", data);
        case 6:
          _context22.next = 11;
          break;
        case 8:
          // on day8-content we wanna mix all companies
          _data = Promise.all([
          // TYW
          fetch("https://graph.instagram.com/me/media?fields=id,media_url,thumbnail_url,caption&access_token=".concat(_envConstants.ENV.INSTAGRAM_TOKENS.tyw, "&limit=16")),
          // TSW
          fetch("https://graph.instagram.com/me/media?fields=id,media_url,thumbnail_url,caption&access_token=".concat(_envConstants.ENV.INSTAGRAM_TOKENS.tsw, "&limit=16")),
          // YNF
          fetch("https://graph.instagram.com/me/media?fields=id,media_url,thumbnail_url,caption&access_token=".concat(_envConstants.ENV.INSTAGRAM_TOKENS.ynf, "&limit=16")),
          // OHSO
          fetch("https://graph.instagram.com/me/media?fields=id,media_url,thumbnail_url,caption&access_token=".concat(_envConstants.ENV.INSTAGRAM_TOKENS.ohso, "&limit=16"))]).then(function (responses) {
            // Get a JSON object from each of the responses
            return Promise.all(responses.map(function (response) {
              return response.json();
            }));
          }).then(function (r) {
            var _r$, _r$2, _r$3, _r$4;
            return [].concat((0, _toConsumableArray2["default"])((_r$ = r[0]) === null || _r$ === void 0 ? void 0 : _r$.data), (0, _toConsumableArray2["default"])((_r$2 = r[1]) === null || _r$2 === void 0 ? void 0 : _r$2.data), (0, _toConsumableArray2["default"])((_r$3 = r[2]) === null || _r$3 === void 0 ? void 0 : _r$3.data), (0, _toConsumableArray2["default"])((_r$4 = r[3]) === null || _r$4 === void 0 ? void 0 : _r$4.data)).sort(function () {
              return Math.random() - 0.5;
            });
          })["catch"](function (error) {
            // if there's an error, log it
            console.log(error);
          });
          if (!(_data && !_data.error)) {
            _context22.next = 11;
            break;
          }
          return _context22.abrupt("return", _data);
        case 11:
          return _context22.abrupt("return", null);
        case 12:
        case "end":
          return _context22.stop();
      }
    }, _callee22);
  }));
  return function getInstagram() {
    return _ref22.apply(this, arguments);
  };
}();
var getTikTokVideos = exports.getTikTokVideos = /*#__PURE__*/function () {
  var _ref23 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee23() {
    var _data$data, response, data;
    return _regenerator["default"].wrap(function _callee23$(_context23) {
      while (1) switch (_context23.prev = _context23.next) {
        case 0:
          _context23.prev = 0;
          _context23.next = 3;
          return fetch("".concat(baseUrl, "/api/get-tiktok-videos"));
        case 3:
          response = _context23.sent;
          _context23.next = 6;
          return response.json();
        case 6:
          data = _context23.sent;
          return _context23.abrupt("return", ((_data$data = data.data) === null || _data$data === void 0 || (_data$data = _data$data.data) === null || _data$data === void 0 ? void 0 : _data$data.videos) || []);
        case 10:
          _context23.prev = 10;
          _context23.t0 = _context23["catch"](0);
          console.error(_context23.t0);
          return _context23.abrupt("return", []);
        case 14:
        case "end":
          return _context23.stop();
      }
    }, _callee23, null, [[0, 10]]);
  }));
  return function getTikTokVideos() {
    return _ref23.apply(this, arguments);
  };
}();
var getWpUserById = exports.getWpUserById = /*#__PURE__*/function () {
  var _ref24 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee24(id) {
    var response, user;
    return _regenerator["default"].wrap(function _callee24$(_context24) {
      while (1) switch (_context24.prev = _context24.next) {
        case 0:
          _context24.prev = 0;
          _context24.next = 3;
          return fetch("".concat(baseUrl, "/wp-json/wp/v2/users/").concat(id));
        case 3:
          response = _context24.sent;
          _context24.next = 6;
          return response.json();
        case 6:
          user = _context24.sent;
          if (!user) {
            _context24.next = 9;
            break;
          }
          return _context24.abrupt("return", (0, _wpApi.parseWPJson)(user));
        case 9:
          return _context24.abrupt("return", null);
        case 12:
          _context24.prev = 12;
          _context24.t0 = _context24["catch"](0);
          return _context24.abrupt("return", _context24.t0);
        case 15:
        case "end":
          return _context24.stop();
      }
    }, _callee24, null, [[0, 12]]);
  }));
  return function getWpUserById(_x21) {
    return _ref24.apply(this, arguments);
  };
}();
var getSubCategory = exports.getSubCategory = /*#__PURE__*/function () {
  var _ref25 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee25(id) {
    var categories;
    return _regenerator["default"].wrap(function _callee25$(_context25) {
      while (1) switch (_context25.prev = _context25.next) {
        case 0:
          _context25.prev = 0;
          _context25.next = 3;
          return (0, _wpApi.getWPResource)("categories?parent=".concat(id, "&per_page=30"));
        case 3:
          categories = _context25.sent;
          return _context25.abrupt("return", categories);
        case 7:
          _context25.prev = 7;
          _context25.t0 = _context25["catch"](0);
          return _context25.abrupt("return", _context25.t0);
        case 10:
        case "end":
          return _context25.stop();
      }
    }, _callee25, null, [[0, 7]]);
  }));
  return function getSubCategory(_x22) {
    return _ref25.apply(this, arguments);
  };
}();
var getSubPages = exports.getSubPages = /*#__PURE__*/function () {
  var _ref26 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee26(id) {
    var categories;
    return _regenerator["default"].wrap(function _callee26$(_context26) {
      while (1) switch (_context26.prev = _context26.next) {
        case 0:
          _context26.prev = 0;
          _context26.next = 3;
          return (0, _wpApi.getWPResource)("pages?parent=".concat(id, "&per_page=30"));
        case 3:
          categories = _context26.sent;
          return _context26.abrupt("return", categories);
        case 7:
          _context26.prev = 7;
          _context26.t0 = _context26["catch"](0);
          return _context26.abrupt("return", _context26.t0);
        case 10:
        case "end":
          return _context26.stop();
      }
    }, _callee26, null, [[0, 7]]);
  }));
  return function getSubPages(_x23) {
    return _ref26.apply(this, arguments);
  };
}();
var getGalleryItems = exports.getGalleryItems = /*#__PURE__*/function () {
  var _ref27 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee27(destId) {
    var galleryItems;
    return _regenerator["default"].wrap(function _callee27$(_context27) {
      while (1) switch (_context27.prev = _context27.next) {
        case 0:
          _context27.next = 2;
          return (0, _wpApi.getWPResource)("gallery".concat(destId ? "?categories=".concat(destId, "&per_page=30") : '?per_page=60'));
        case 2:
          galleryItems = _context27.sent;
          if (!galleryItems) {
            _context27.next = 5;
            break;
          }
          return _context27.abrupt("return", galleryItems);
        case 5:
          return _context27.abrupt("return", null);
        case 6:
        case "end":
          return _context27.stop();
      }
    }, _callee27);
  }));
  return function getGalleryItems(_x24) {
    return _ref27.apply(this, arguments);
  };
}();
var getGalleryTags = exports.getGalleryTags = /*#__PURE__*/function () {
  var _ref28 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee28() {
    var tags;
    return _regenerator["default"].wrap(function _callee28$(_context28) {
      while (1) switch (_context28.prev = _context28.next) {
        case 0:
          _context28.next = 2;
          return (0, _wpApi.getWPResource)('gallerytag');
        case 2:
          tags = _context28.sent;
          if (!Array.isArray(tags)) {
            _context28.next = 5;
            break;
          }
          return _context28.abrupt("return", tags);
        case 5:
          return _context28.abrupt("return", []);
        case 6:
        case "end":
          return _context28.stop();
      }
    }, _callee28);
  }));
  return function getGalleryTags() {
    return _ref28.apply(this, arguments);
  };
}();